// extracted by mini-css-extract-plugin
module.exports = {"heading":"ArticlesList_heading__y6hF5","list":"ArticlesList_list__MtT6l","ctaBanner":"ArticlesList_ctaBanner___58ea"};